// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.
//
// THE NUMBER IN THE URL IS THE VERSION NUMBER, NOT AN ID. `versions/2` is
// "version 2 of this plan", the thing a person says out loud. The database id
// of that row is a different number and it is NEVER what goes here. The two are
// easy to swap and the mistake is silent: id 31 is a perfectly valid-looking
// version number.
//
// And nothing in this file mentions `document_version_id`. The content of a
// plan lives in `document_versions`, and the SERVER writes those snapshots —
// saving a draft writes a new snapshot and moves the pointer, without changing
// the version number. A panel that sent one would be inventing a pointer into
// somebody else's table.
export const planPaths = {
    list:   ()   => 'admin/plans',
    detail: (id) => `admin/plans/${id}`,

    versions: (id) => `admin/plans/${id}/versions`,
    version:  (id, number) => `admin/plans/${id}/versions/${number}`,

    // The three state moves. Each one is a verb of its own because each is a
    // different decision: presenting is not approving, and returning is not
    // editing.
    submit:         (id, number) => `admin/plans/${id}/versions/${number}/submit`,
    requestChanges: (id, number) => `admin/plans/${id}/versions/${number}/request-changes`,
    approve:        (id, number) => `admin/plans/${id}/versions/${number}/approve`,
};
